export default __webpack_public_path__ + "static/media/eyes.23237e91.ogg";